"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _abstract = _interopRequireDefault(require("./abstract"));

require("./line");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _abstract["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@antv/f2/lib/component/axis/index.js
// module id = 377
// module chunks = 3